import React, { useEffect, useState, useContext } from 'react';
import { createRole, updateRole } from '../../../Utility/Api';
import { WarehouseContext } from '../../../Utility/UserContext';
import { toast } from 'react-toastify';

const RoleForm = ({ selectedRole, setShowModal, fetchRoles, menuList }) => {
  const [formData, setFormData] = useState({ role_title: '', menu_id: [], status: '' });
  const [selectedMenus, setSelectedMenus] = useState([]);
  const [errors, setErrors] = useState({});
  const { showLoader, hideLoader } = useContext(WarehouseContext);

  useEffect(() => {
    if (selectedRole) {
      const parsedMenus = JSON.parse(selectedRole?.menu_id || '[]');
      setSelectedMenus(parsedMenus);
      setFormData({
        role_title: selectedRole.role_title || '',
        menu_id: parsedMenus,
        status: selectedRole.status?.toString() || '',
      });
    } else {
      resetForm();
    }
  }, [selectedRole]);

  const resetForm = () => {
    setFormData({ role_title: '', menu_id: [], status: '' });
    setSelectedMenus([]);
    setErrors({});
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const updateMenuState = (updated) => {
    setSelectedMenus(updated);
    setFormData((prev) => ({ ...prev, menu_id: updated }));
    setErrors((prev) => ({ ...prev, menu_id: '' }));
  };

  const handleMenuSelect = (menu, checked) => {
    const updated = checked
      ? [...selectedMenus, { menu: menu.route, readonly: true }]
      : selectedMenus.filter((m) => m.menu !== menu.route);
    updateMenuState(updated);
  };

  const handleWritableChange = (menu, checked) => {
    const updated = selectedMenus.map((m) =>
      m.menu === menu.route ? { ...m, readonly: !checked } : m
    );
    updateMenuState(updated);
  };

  const validate = () => {
    const validationErrors = {};
    if (!formData.role_title) validationErrors.role_title = 'Role title is required.';
    if (!formData.menu_id?.length) validationErrors.menu_id = 'Menu permissions are required.';
    return validationErrors;
  };

  const handleSubmit = async (e) => {
    showLoader();
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      hideLoader();
      return;
    }

    const payload = {
      role: formData.role_title,
      menu_id: formData.menu_id,
      status: formData.status === '1' ? 1 : 0,
    };

    try {
      if (selectedRole) {
        await updateRole(selectedRole.role_id, payload);
        hideLoader();
        toast.success('Role Updated Successfully');
      } else {
        await createRole(payload);
        hideLoader();
        toast.success('Role Created Successfully');
      }
      setShowModal(false);
      fetchRoles();
    } catch (error) {
      console.error('Error Saving role:', error?.message || error);
      toast.error('Error saving role');
    } finally {
      hideLoader();
    }
  };

  return (
    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content" style={{ fontFamily: 'Poppins' }}>
          <div className="modal-header">
            <h5 className="modal-title">{selectedRole ? 'Edit Role' : 'Add Role'}</h5>
            <button className="btn-close" onClick={() => setShowModal(false)}></button>
          </div>

          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              {/* Role Title */}
              <div className="form-group mb-3">
                <label>Role Title</label>
                <input
                  type="text"
                  name="role_title"
                  value={formData.role_title}
                  onChange={handleChange}
                  className="form-control"
                  disabled={['Employee', 'Manager', 'Super Admin'].includes(formData.role_title)}
                />
                {errors.role_title && <small className="text-danger mx-2">{errors.role_title}</small>}
              </div>

              {/* Menu Permissions */}
              <div className="form-group mb-3">
                <label>Menu Permissions</label>
                <div className="form-control" style={{ height: 'auto', maxHeight: 300, overflowY: 'scroll' }}>
                  {menuList.map((menu) => {
                    const selected = selectedMenus?.find((m) => m.menu === menu.route) || {};
                    const isSelected = !!selectedMenus?.find((m) => m.menu === menu.route);

                    return (
                      <div
                        key={menu.route}
                        className="border-bottom pb-2 mb-2 d-flex align-items-center justify-content-between"
                      >
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`menu-${menu.route}`}
                            checked={isSelected}
                            onChange={(e) => handleMenuSelect(menu, e.target.checked)}
                          />
                          <label className="form-check-label fw-bold mx-2" htmlFor={`menu-${menu.route}`}>
                            {menu.title}
                          </label>
                        </div>

                        <div className={menu.title ==="Sales Window" ?"d-none":"form-check"}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`write-${menu.route}`}
                            disabled={!isSelected}
                            checked={isSelected ? !selected.readonly : false}
                            onChange={(e) => handleWritableChange(menu, e.target.checked)}
                          />
                          <label className="form-check-label" htmlFor={`write-${menu.route}`}>
                            {"Writable"}
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {errors.menu_id && <small className="text-danger mx-2">{errors.menu_id}</small>}
              </div>

              {/* Submit + Cancel */}
              <div className="d-flex justify-content-end">
                <button type="submit" className="btn btn-success me-2">
                  {selectedRole ? 'Update Role' : 'Add Role'}
                </button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleForm;